import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "3.2 Сохранение доверенности", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, " Вы можете подписать доверенность электронной подписью или скачать её для подписания в удобном Вам формате ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Нажмите чтобы скачать доверенность", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, " На этом работа с доверенностью окончена и мы переходим к формированию заявления ", -1)
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("button", {
        type: "button",
        class: "blue_btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download_signatory && _ctx.download_signatory(...args))),
        style: {"float":"left","margin-left":"10px"}
      }, " Скачать доверенность "),
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_13)
  ], 64))
}